<template>
  <div class="index">
    <!-- 首页首页 -->
    <!-- <Layout /> -->
    <!-- <menu-bar /> -->
    <!-- <router-view /> -->
    <el-row :gutter="6">
      <el-col :span="columns.col1">
        <!-- 筛选栏 -->
        <div>
          <!-- 查找参数区 -->
          <div class="filter-container">
            <!-- <el-input placeholder="请输入车辆ID" v-model="listQueryCar.params.id" style="width: 250px" class="filter-item"
              @input="e => listQueryCar.params.id = e.replace(/[^\d]/g,'')" maxlength="20"></el-input>
            <el-button class="filter-item" type="primary" icon="el-icon-search" style="margin-left: 5px"
              @click="loadPageData(true)">
              搜索
            </el-button>
            <el-radio-group v-model="listQueryCar.params.isRobot" @change="loadPageData(true)" class="isRobotRadio">
              <el-radio :label="0">真车</el-radio>
              <el-radio :label="1">模拟车</el-radio>
              <el-radio :label="2">carla</el-radio>
            </el-radio-group> -->
            <searchContent @queryDevice="queryDevice"></searchContent>
            
            <el-button-group style="padding-top: 5px;">
              <el-button type="success" @click="listQueryClear" icon="el-icon-delete" plain
                style="padding-right: 45px;">&nbsp;&nbsp;清除类型条件</el-button>
              <el-button type="success" @click="handleShowRoomMap" plain style="padding-left: 45px;">
                {{ showRoomMapMsg }}点云地图<i class="el-icon-search el-icon--right"></i>
              </el-button>
            </el-button-group>
          </div>

          <!-- 数据列表区 -->
          <el-table :data="listDataCar" v-loading="listLoadingCar" border highlight-current-row
            style="width: 100%;align: center;">
            <el-table-column prop="isRobot" v-if="false"></el-table-column>
            <!-- <el-table-column prop="index" label="序号" width="60px" align="center">
          </el-table-column> -->
            <!-- <el-table-column type="selection" :reserve-selection="true" width="50" align="center">
            </el-table-column> -->
            <el-table-column prop="name" label="机器人名称" align="center" width="165px"></el-table-column>
            <el-table-column prop="status" label="机器人状态" align="center" width="100px" :formatter="formatCarStatus">
            </el-table-column>
            <el-table-column prop="operator" label="操作" align="center">
              <template v-slot:="{row,$index}">
                <el-button type="primary" size="mini" @click="locateCarOnMap(row)" plain>
                  查看
                </el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 分页栏 -->
          <pagination :total="totalCountsCar" @pagination="handlePageChangeCar" layout='sizes,prev, pager, next'
            :page="listQueryCar.pageIndex" small :pager-count="5">
          </pagination>

        </div>
      </el-col>
      <el-col :span="columns.col2">
        <!-- 点云地图 -->
        <div class="point-cloud-map">
          <!-- 点云地图 -->
          <table id="roomMapTable"></table>
        </div>
      </el-col>
      <el-col :span="columns.col3">
        <!-- 地图栏 -->
        <div>
          <baidu-map class="bm-view" :center="{lng: 61, lat: 16.55}" scroll-wheel-zoom @ready="bm_ready"
            @zoomend="bm_zoomend" :zoom="1" :continuous-zoom="false">
            <!-- 控件 -->
            <bm-navigation anchor="BMAP_ANCHOR_TOP_LEFT"></bm-navigation>
            <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_RIGHT">
            </bm-map-type>
            <bm-scale anchor="BMAP_ANCHOR_BOTTOM_LEFT"></bm-scale>
            <!-- 点聚合 maxZoom为点聚合的最大缩放级别 minClusterSize为点聚合的最少数量，此处为当缩放级别小于等于8时候，就以点聚合的方式进行展示 -->
            <bml-marker-clusterer :averageCenter="true" :maxZoom="8" :minClusterSize="1">
              <bm-marker v-for="(item,index) in entitysAllCarList" :key="index"
                :position="{lng: item.baiduLongitude, lat: item.baiduLatitude}" :massClear="false"
                @click="infoWindowOpen(index)" :icon="getCarStatusIcon(item.status)">
                <bm-info-window v-if="item.status != 1" :show="item.isShow" :closeOnClick="false"
                  @close="infoWindowClose(index)">
                  <p class="bm-marker-info">
                    机器人名称:&nbsp;{{item.name}}
                  </p>
                  <p class="bm-marker-info">
                    机器人ID:&nbsp;{{item.id}}
                  </p>
                  <p class="bm-marker-info">
                    行驶速度:&nbsp;{{item.speed}}km/h
                  </p>
                 <!-- <p class="bm-marker-info">
                    行驶里程:&nbsp;600km
                  </p> -->
                  <p class="bm-marker-info">
                    机器人电量:&nbsp;{{item.powerLeft}}%
                  </p>
                  <p class="bm-marker-info">
                    工作状态:&nbsp;{{getCarStatusName(item.status)}}
                  </p>
                  <p class="bm-marker-info-button-container">
                  <div style="display:inline-block;margin:auto">
                    <router-link :to="{name: 'car_monitor', params:{currentCar:JSON.stringify(item)}}">
                      <el-button size="mini" type="primary">详情</el-button>
                    </router-link>
                  </div>
                  <div style="display:inline-block;margin-left: 10px;">
                    <el-button size="mini" @click="infoWindowClose(index)" plain>关闭</el-button>
                  </div>
                  </p>
                </bm-info-window>

                <bm-info-window v-if="item.status===1" :show="item.isShow" :closeOnClick="false"
                  @close="infoWindowClose(index)">
                  <p class="bm-marker-info">
                    机器人名称:&nbsp;{{item.name}}
                  </p>
                  <p class="bm-marker-info">
                    机器人ID:&nbsp;{{item.id}}
                  </p>
                  <p class="bm-marker-info">
                    机器人状态:&nbsp;离线
                    <!-- {{getCarStatusName(item.status)}} -->
                  </p>
                  <p class="bm-marker-info">
                    离线时间:&nbsp;{{item.updateTime}}
                    <!-- {{getCarStatusName(item.status)}} -->
                  </p>
                </bm-info-window>
              </bm-marker>
            </bml-marker-clusterer>
          </baidu-map>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  // 懒加载
  const Layout = () => import('components/content/layout')
  // 分页
  import Pagination from '@/components/common/Pagination'
  // 点聚合
  import {
    BmlMarkerClusterer
  } from 'vue-baidu-map'
  import {
    carList
  } from '@/api/car'

  import {
    carListByEntityId
  } from '@/api/car'
  import {BmlLushu} from 'vue-baidu-map'
  import {
    getCarLocationMapApi
  } from '@/api/indexApi'
  import {
    canvasPic
  } from '@/api/indexApi'
  import {
    imgUrl
  } from '@/api/indexApi'
  import {
    localDown
  } from '@/api/file'

  import SearchContent from './searchContent'
	
	import free from '../assets/img/car_free.9.png'
	import exception from '../assets/img/car_exception.9.png'
	import notStart from '../assets/img/car_not_start.9.png'
	

  export default {
    name: 'Index',
    components: {
      Pagination,
      BmlMarkerClusterer,
      SearchContent,
      BmlLushu
    },
    data() {
      return {
        //分栏列宽
        columns: {
          col1: 5,
          col2: 0,
          col3: 18,
          show_zoom_map: false
        },
        //车辆状态map
        carStatusMap: {
          0: "正常",
          1: "未接入",
          2: "故障",
          3: "建图中",
          4: "建轨中",
          5: "自动任务",
          6: "遥控驾驶",
          7: "待机",
          64: "异常",
        },
        showRoomMapMsg: "显示",
        //用于表示是否正在加载列表数据
        listLoadingCar: true,
        //用于存放根据搜索条件查询的当前页的设备数据
        listDataCar: [],
        //用于存放根据搜索条件查询的设全部设备数据，用于在地图中渲染设备节点
        entitysAllCarList: [],
        //用于存放当前正在查看的的设备，默认为null
        checkedCarInfo: null,
        //符合查询条件的设备总数，用于列表的分页组件
        totalCountsCar: 0,
        //车辆查询条件
        listQueryCar: {
          entityId: this.$store.getters['user/entityId'],
          pageIndex: 1,
          pageSize: 10,
          queryParams: null,
          params: {
            id: undefined,
            isRobot: undefined,
          },
          fuzzySearch: true
        },
        //用于判断是否选中车辆
        isCheckCar: false,
        // 点云地图
        fileMap: undefined,
        //用于判断是否是首次查询加载页面数据，默认为true，清空查询条件也会将其设置为true
        //为true时，会调用setViewport，让所有设备（标记点）都显示在同一地图内
        isFirstLoadPageData: true,
        size: [400, 400],
        minSize: 20,
        showRoomMapInterval: undefined,
        insideCarImg: undefined,
        tailImg: undefined,
        //用于存储百度地图的map、BMap对象，二者用于对地图的动态操作，于@ready的方法中进行初始化
        map: undefined,
        BMap: undefined,
        //默认的地图中心点以及缩放级别
        bdmap: {
          center: {
            lng: 116.404,
            lat: 39.915
          }, // "北京",
          zoom: 1
        },
        //当前选中的车辆
        curCheckCar: [],
        //ICON图片资源的引用
        iconPath: {
          free: require('assets/img/car_free.9.png'),
          coin: require('assets/img/car_coin_renting.9.png'),
          exception: require('assets/img/car_exception.9.png'),
          reserved: require('assets/img/car_indigo.9.png'),
          mobile: require('assets/img/car_mobile_renting.9.png'),
          maintain: require('assets/img/car_maintaining.9.png'),
          notStart: require('assets/img/car_not_start.9.png')
        },
        //小车轨迹
        // mobileIcon:{
        //     url:require('assets/img/car_mobile_renting.9.png'),
        //     size:{width:50,height:50},
        //     opts:{
        //         imageSize:{width: 50, height: 50},
        //         // anchor: {width: 27, height: 13},
        //     },
        // },
        //用于存储获取设备位置list的定时器
        getLocationInterval: undefined,
        //存储用于刷新地图内容的定时器
        refreshMapDataInterval: undefined,
        // bmlLushu_path:[],
        // bmlLushu_play:false,
        // curLuShuCar:"",
        tagsAll: null
      }
    },
    methods: {

      queryDevice(tagsAll) {
        this.tagsAll = tagsAll;

        this.pageListCarsByConditions();
      },

      /**
       * 处理车辆在线状态
       * @param {Object} row
       * @status enable
       */
      formatCarStatus(row) {
        let onlineStatusArray = [0, 3, 4, 5, 6, 7];
        let errorStatusArray = [2, 64];

        if (onlineStatusArray.indexOf(row.status) >= 0) {
          return "在线";
        }
        if (errorStatusArray.indexOf(row.status) >= 0) {
          return "故障";
        }

        return "离线";
      },
      /**
       *  根据车辆状态获取对应ICON
       * @param {Object} status
       * @status enbale
       */
      getCarStatusIcon(status) {
        let onlineStatusArray = [0, 3, 4, 5, 6, 7];
        let errorStatusArray = [2, 64];

        let carIcon = {
          size: {
            width: 50,
            height: 65
          },
          opts: {
            imageSize: {
              width: 50,
              height: 50
            }
          }
        };

        if (onlineStatusArray.indexOf(status) >= 0) {
          carIcon.url = free; //this.iconPath
        } else if (errorStatusArray.indexOf(status) >= 0) {
          carIcon.url = exception; //this.iconPath
        } else {
          carIcon.url = notStart; //this.iconPath
        }
        return carIcon;
      },

      getCarStatusName(status) {
        if (status in this.carStatusMap) {
          return this.carStatusMap[status];
        }
        return "离线";
      },

      /**
       * 查询当前单位及其子单位的车辆(地图中使用)
       * @param boolean isRefresh 是否为自动刷新 默认为false
       * @status enable
       */
      listCarsByEntityId(isRefresh = false) {
        //发起请求
        carListByEntityId(this.listQueryCar, this.tagsAll).then(res => {
          let data = res.data;
          // 对后端数据进行解析
          this.entitysAllCarList = data.map((item, index) => {
            //默认不显示信息窗口
            item.isShow = false; //是否显示（信息窗口）
            //当本次加载数据为定时刷新时
            if (isRefresh) {
              //判断是否正在查看设备
              //checkedCarInfo === null等，表明无正在查看的设备
              if (this.checkedCarInfo === null || this.checkedCarInfo === undefined || this.checkedCarInfo === "") {
                return item;
              }
              //如果是正在查看的设备，且信息框被打开，则保持打开状态
              if (this.checkedCarInfo.id === item.id && this.checkedCarInfo.isShow === true) {
                item.isShow = true; //是否显示（信息窗口）
              }
            }
            return item;
          })
          //如果属于首次加载（进入页面或清空查询条件后）
          if (this.isFirstLoadPageData) {
            //则将使得地图完全显示所有设备标记节点
            this.drawAllCarPointsOnMap(this.entitysAllCarList);
          }
          //并修改“首次加载”标记为false
          this.isFirstLoadPageData = false;
        });
      },
      /**
       * 分页查询当前单位及其子单位的车辆
       * @status enable
       */
      pageListCarsByConditions() {
        //开始加载数据列表
        //显示加载图标
        this.listLoadingCar = true;
        // 处理查询数据封装Map

        if (this.tagsAll == null || this.tagsAll == '') {
          this.listQueryCar.queryParams = null;
        } else {

          /* let map = new Map()
          for (var key in this.tagsAll) {
            map.set(this.tagsAll[key].split(":")[0], this.tagsAll[key].split(":")[1])
          }
          params = map; */
          this.listQueryCar.queryParams = this.tagsAll;
        }
        console.log(this.listQueryCar.queryParams);

        carList(this.listQueryCar, null ).then(res => {
          let data = res.pageData;
          this.totalCountsCar = data.totalCounts;
          // 对后端数据进行解析
          this.listDataCar = data.datas.map((item, index) => {
            //所有设备的isShow默认为false，即使不于地图中展示
            item.isShow = false;
            return item;
          });
          //加载完成//结束加载
          this.listLoadingCar = false;
        });
      },

      /**
       * 在地图上初始化渲染车辆标记
       * @status enable
       */
      drawAllCarPointsOnMap(carPoints) {
        let bmPoints = []
        for (const item of carPoints) {
          //经纬度
          bmPoints.push(new this.BMap.Point(item.baiduLongitude, item.baiduLatitude))
        }
        this.map.setViewport(bmPoints)
      },

      /**
       * 加载页面数据
       * @param {Object} isFlag
       * @status enable
       */
      loadPageData(isFlag = false) {
        if (isFlag) {
          this.listQueryCar.pageIndex = 1;
          // this.isFirstLoadPageData = true;
        }

        //加载全部数据
        this.listCarsByEntityId();

        //加载分页数据
        this.pageListCarsByConditions();
      },

      /**
       * 处理小车列表翻页
       * @param {Object} data
       * @status enable
       */
      handlePageChangeCar(data) {
        console.log("当前页", data);
        this.currentPageIndex = data.page
        this.listQueryCar.pageIndex = data.page
        this.listQueryCar.pageSize = data.limit
        //列表翻页只刷新列表，不刷新地图内容
        this.pageListCarsByConditions()
      },
      /**
       * 清理类型条件
       * @status enable
       */
      listQueryClear() {
        this.listQueryCar.params.id = undefined
        this.listQueryCar.params.isRobot = undefined
        //清空后第一次加载页面数据
        this.isFirstLoadPageData = true;
        this.loadPageData();
      },
      /**
       *  在地图上定位车辆
       * @param {Object} row
       */
      locateCarOnMap(row) {
        //目标所在经纬度
        let point = new BMap.Point(row.baiduLongitude, row.baiduLatitude);
        //定位
        this.map.setCenter(point);
        this.map.setZoom(19);
        //二次定位防止中心偏移
        this.map.setCenter(point);
        this.map.setZoom(19);

        let currentId = row.id;
        //于地图中的全部设备中查找到需要定位的设备
        let currentCarInfo = this.entitysAllCarList.find(function(item, index, arr) {
          return item.id == currentId;
        })
        this.checkedCarInfo = currentCarInfo;
        //直接修改状态，可能定位/缩放还未完成便修改了是否显示的状态，定位/缩放过程中会关闭信息窗口
        //所以需要地图延时显示信息框
        setTimeout(function() {
          currentCarInfo.isShow = true;
        }, 300)
      },

      /**
       * handleFilterCar 用于请求车辆数据
       * @status disable
       */
      handleFilterCar(isFlag = false) {
        if (isFlag) {
          this.listQueryCar.pageIndex = 1;
        }
        this.listLoadingCar = true
        //请求当前单位及其子单位的所有车辆
        carListByEntityId(this.listQueryCar, null).then(res => {
          let data = res.data
          // 对后端数据进行解析
          this.entitysAllCarList = data.map((item, index) => {
            item.isShow = false
            return item
          })
        })


        carList(this.listQueryCar, null).then(res => {
          let data = res.pageData
          this.totalCountsCar = data.totalCounts
          // 对后端数据进行解析
          // this.listDataCar=data.datas
          this.listDataCar = data.datas.map((item, index) => {
            item.isShow = false
            return item
            // return {
            //   index: index+1,
            //   id: item.id,
            //   isRobot:item.isRobot,

            // }
          })
          this.listLoadingCar = false
          this.handleChooseCar([])
        })
      },


      //--------------------------------------------------------------------------------------------------------------------------------------------
      //@status disable
      /**
       * 显示点云地图
       */
      handleShowRoomMap() {
        clearInterval(this.showRoomMapInterval)
        if (this.columns.show_zoom_map) {
          this.columns.col2 = 0
          this.columns.col3 = 18
          this.showRoomMapMsg = "显示"
          clearInterval(this.showRoomMapInterval)
        } else {
          if (!this.isCheckCar) {
            this.$message({
              type: 'info',
              message: '请选择要显示的机器人'
            })
            return
          }
          this.columns.col2 = 12
          this.columns.col3 = 6
          this.showRoomMapMsg = "隐藏"
          this.showRoomMap()
        }
        this.columns.show_zoom_map = !this.columns.show_zoom_map
      },
      initRoomMapTable(ids) {
        document.querySelector("#roomMapTable").innerHTML = ""
        let left = ids.length;
        let pos = left % 2;
        let lines = 0;
        if (pos == 1) {
          lines = (left + 1) / 2;
        } else {
          lines = left / 2;
        }
        let inner = "";
        for (let i = 0; i < lines; i++) {
          let id1 = 2 * i;
          let id2 = id1 + 1;
          inner += "<tr><td><div id='div" + id1 + "'><canvas id='canvas" + id1 +
            "' width='400' height='400' style='border:1px solid #d3d3d3;background:#ffffff;'>不支持canvas</canvas></div></td><td><div id='div" +
            id2 + "'><canvas id='canvas" + id2 +
            "' width='400' height='400' style='border:1px solid #d3d3d3;background:#ffffff;'>不支持canvas</canvas></div></td></tr>";
          if (id2 < ids.length) {
            inner += "<tr><td>" + ids[id1] + "</td><td>" + ids[id2] + "</td></tr>"
          } else {
            inner += "<tr><td>" + ids[id1] + "</td><td></td></tr>"
          }
        }
        document.querySelector("#roomMapTable").innerHTML = inner
        let that = this
        // this.showRoomMapInterval=setInterval(function(){
        //         that.paintByIds(ids);
        // },5000);
      },
      async showRoomMap() {
        clearInterval(this.showRoomMapInterval)
        let ids = [];
        if (this.isCheckCar) {
          ids = this.curCheckCar.map(item => {
            return item.id
          })
        }
        this.initRoomMapTable(ids)
        this.fileMap.clear()
        let count = 0
        let that = this
        let timer;
        for (let carId of ids) {
          canvasPic(carId).then(res => {
            // this.fileMap.carId=imgUrl('1',carId,res.message)
            localDown('1', carId, res.message).then(res => {
              this.fileMap.set(carId, window.URL.createObjectURL(new Blob([res])))
              count++
              if (count == ids.length) {
                // this.paintByIds(ids)
                this.showRoomMapInterval = setInterval(function() {
                  that.paintByIds(ids);
                }, 5000);
              }
            })
          })
          // 睡眠解决 ftp重新连接报错问题
          await this.sleep(1000);
        }
      },
      sleep(time) {
        return new Promise((resolve) => setTimeout(resolve, time));
      },
      paintByIds(ids) {
        let that = this
        for (let i = 0; i < ids.length; i++) {
          let carId = ids[i];
          getCarLocationMapApi(carId).then(data => {
            if (data) {
              let canvasId = "#canvas" + i;
              let canvasItem = document.querySelector(canvasId);
              this.loadImages(this.fileMap.get(carId), function(images) {
                let ctx = canvasItem.getContext("2d");
                ctx.clearRect(0, 0, 400, 400);
                ctx.drawImage(images, 0, 0, that.size[0], that.size[1]);
                let present = true;
                for (let i = data.length; i-- > 0;) {
                  if (present) {
                    console.log(data[i]);
                    that.paintImg(canvasItem, that.insideCarImg, data[i].x, data[i].y, that.minSize + i, that
                      .minSize + i);
                    present = false;
                  } else {
                    that.paintImg(canvasItem, that.tailImg, data[i].x, data[i].y, that.minSize + i, that
                      .minSize + i);
                  }
                }
              });

            } else {

            }
          })
        }
      },
      // 异步加载图片
      loadImages(url, callback) {
        let images = new Image();
        let that = this
        images.onload = function() {
          that.size = that.calcSize(images, 400);
          callback(images);
        };
        if (url != undefined) {
          images.src = url;
        }
      },
      paintImg(myCanvas, img, x, y, width, height) {
        let ctx = myCanvas.getContext("2d");
        ctx.drawImage(img, x, y, width, height);
      },
      // 计算大小
      calcSize(img, size) {
        let result = [];
        // console.log(img.width,img.height)
        let width = img.width;
        let height = img.height;
        if (width >= height) {
          result.push(size);
          result.push(height * size / width);
        } else {
          result.push(width * size / height);
          result.push(size);
        }
        return result;
      },
      //---------------------------------------------------------------------------------------------------------------------------------------

      /**
       * 百度地图ready，存储BMap和map对象
       * @status enable
       */
      bm_ready({
        BMap,
        map
      }) {
        console.log("BaiduMap is ready")
        this.BMap = BMap
        this.map = map
      },
      /**
       * 百度地图缩放级别改变后触发，该部分主要触发路书的显示，暂时不使用路书
       * @status enable
       */
      bm_zoomend({
        type,
        target
      }) {
        //TODO 暂时不做使用
        return;
        let zoomNum = target.getZoom()
        let list = this.curCheckCar;
        console.log(zoomNum)
        if (zoomNum > 18) {
          //关闭定时任务
          clearInterval(this.getLocationInterval)
          let that = this
          if (that.checkedCarInfo != null) {
            that.getCarLocationMap(that.checkedCarInfo.id)
          } else {
            console.log("未选择车辆")
          }
        } else {
          //关闭定时任务
          clearInterval(this.getLocationInterval)
          this.bmlLushu_play = false
          this.bmlLushu_path = []
        }
      },
      bmlStop() {
        this.bmlLushu_play = false
      },

      /**
       * 点击标注点，打开其对用弹出框
       * @param {Object} pos
       * @status enable
       */
      infoWindowOpen(pos) {
        let zoomLevel = this.map.getZoom();
        // console.log(zoomLevel);
        //缩放级别小于16时，定位并缩放至级别19
        if (zoomLevel < 16) {
          this.locateCarOnMap(this.entitysAllCarList[pos]);
        } else {
          //否则直接显示信息窗口
          this.entitysAllCarList[pos].isShow = true;
          //并将点击的设备标记选中
          this.checkedCarInfo = this.entitysAllCarList[pos];
          console.log(this.checkedCarInfo);
        }

      },
      /**
       * 标注点弹窗关闭
       * @param {Object} pos
       * @status enable
       */
      infoWindowClose(pos) {
        //隐藏信息窗口
        this.entitysAllCarList[pos].isShow = false;
        //置空选中的设备
        this.checkedCarInfo = null;
      },
      /**
       *  获取车辆位置
       * @param {Object} carId
       * @status enable
       */
      getCarLocationMap(carId) {

        // this.map.clearOverlays();
        // this.curCheckCar = [];

        // map.clearOverlays(); //删除所有点
        let that = this;
        // that.map.clearOverlays();
        getCarLocationMapApi(carId).then(res => {
          console.log(res)
          if (res != null && res.length != 0) {
            if (res.length > 2) {
              // let tmp=res.map(item=>{
              //     return{
              //         lng: item.longitude,
              //         lat: item.latitude,
              //     }
              // })
              // that.bmlLushu_path=tmp.map(item=>{
              //     return new BMap.Point(item.lng,item.lat)
              // })
              // that.curLuShuCar=that.curCheckCar[0].id
              // console.log(that.bmlLushu_path)
              // that.map.setCenter(new BMap.Point(that.bmlLushu_path[0].lng,that.bmlLushu_path[0].lat))
              // that.bmlLushu_play=true
              this.beginLushu(res, carId)
            } else {
              console.log("车辆id:" + carId + "轨迹数据长度不够");
            }
          } else {
            console.log("车辆id:" + carId + "无轨迹数据");
          }
        })
      },
      beginLushu(data, carLushuId) {
        this.map.clearOverlays();
        let accDataNew = [];
        //去掉第一条值，从第二条数据开始取值
        for (let i = 0; i < data.length; i++) {
          if (i == 0) {
            continue;
          }
          accDataNew.push(data[i]);
        }
        //获取data数据中的经纬度点并格式化点为BMap点
        let accPoints = [];
        accPoints = this.getBMapPoints(accDataNew);
        //目标icon
        let accIcon = new BMap.Icon(require('assets/img/car_mobile_renting.9.png'), new BMap.Size(45, 46), {
          // anchor: new BMap.Size(20, 20),
          imageSize: {
            width: 50,
            height: 50
          },
        });

        let polyline = new BMap.Polyline(accPoints, {
          strokeColor: "#DC143C",
          strokeWeight: 10
        });
        this.map.addOverlay(polyline); //添加轨迹到地图

        let lushu = new BMapLib.LuShu(this.map, accPoints, {
          defaultContent: carLushuId,
          speed: 10, //速度，单位米每秒
          icon: accIcon, //声明高铁标注
          autoView: true,
          enableRotation: false,
          landmarkPois: ''
        });
        this.map.setCenter(accPoints[0])
        lushu.start();
      },
      /**
       *  将车辆位置数据转化成经纬度坐标点
       * @param {Object} data
       * @status enable
       */
      getBMapPoints(data) {
        var points = [];
        for (var i = 0; i < data.length; i++) {
          var x = data[i].longitude;
          var y = data[i].latitude;
          points[i] = new BMap.Point(x, y);
        }
        return points;
      },
      /**
       * 远程接管事件
       * @param {Object} row
       * @status disable
       */
      showVedio(row) {
        if (row.isRobot !== 0) {
          this.$message({
            type: 'info',
            message: '非真车不支持接管!'
          });
          return
        }
        this.$message({
          type: 'info',
          message: '接管机器人:' + row.id + ''
        });
        localStorage.setItem('remoteCarId', row.id)
        localStorage.setItem('remoteCarType', row.typeId)
        this.$router.push({
          name: 'remote',
        });
      },
      /**
       * 离开当前页面的判断
       * @status enable
       */
      checkLeave() {
        clearInterval(this.getLocationInterval);
        clearInterval(this.showRoomMapInterval);
        clearInterval(this.refreshMapDataInterval);
        console.log("离开首页！");
      },
    },
    beforeDestroy() {
      this.checkLeave()
    },
    destroyed() {
      window.removeEventListener('beforeunload', this.checkLeave)
    },
    mounted() {
      this.fileMap = new Map()
      this.insideCarImg = new Image()
      this.insideCarImg.src = require('assets/img/car_indigo.9.png')
      this.tailImg = new Image()
      this.tailImg.src = require('assets/img/tail.png')
      window.addEventListener('beforeunload', this.checkLeave)
      //进入页面，加载页面数据
      //加载初始数据
      this.loadPageData()
      //定时刷新数据
      // let that = this;
      // this.refreshMapDataInterval = setInterval(function() {
      //   console.log("刷新地图")
      //   //isRefresh设置为true，表示本次加载数据为定时刷新，不影响地图当前的状态
      //   that.listCarsByEntityId(true);
      // }, 15000);
    }
  }
</script>

<style scoped>
  .bm-view {
    width: 100%;
    height: 800px;
  }

  .index {
    padding-left: 10px;
    padding-top: 10px;
  }

  .bm-marker-info {
    font-size: 14px;
  }

  .bm-marker-info-button-container {
    margin-top: 5px;
  }

  .point-cloud-map {
    height: 800px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    overflow-y: auto;
  }

  .isRobotRadio {

    margin-left: 50px;
  }
</style>>
